import React, { ReactNode } from 'react'

import Box from 'components_new/atoms/Box'
import FormControlLabel from 'components_new/atoms/FormControlLabel'
import Icon, { IconProps } from 'components_new/atoms/Icon'
import Radio from 'components_new/atoms/Radio'
import Text from 'components_new/atoms/Text'

interface RadioItemProps {
  checked: boolean
  disabled?: boolean
  // If true, the label is rendered as it is passed without an
  // additional text node:
  disableText?: boolean
  edge?: 'end' | 'start'
  endIcon?: Omit<IconProps, 'color' | 'sx'>
  fullWidth?: boolean
  hover?: boolean
  label: ReactNode
  onChange?: () => void
  size?: 'small' | 'medium'
  sx?: object
  TextProps?: object
}

const RadioItem = (props: RadioItemProps) => {
  const {
    checked,
    disabled,
    disableText,
    edge,
    endIcon,
    fullWidth,
    hover,
    label,
    onChange,
    size,
    sx,
    TextProps
  } = props

  return (
    <FormControlLabel
      control={
        <Radio
          checked={checked}
          disabled={disabled}
          edge={edge}
          onChange={onChange}
          size={size}
        />
      }
      disableTypography={disableText || Boolean(endIcon)}
      label={
        endIcon ? (
          <Box
            component="span"
            sx={{ display: 'flex', flex: 1, justifyContent: 'space-between' }}
          >
            <Text
              {...TextProps}
              component="span"
              sx={{ 'label:hover &': { color: 'text.primary' } }}
            >
              {label}
            </Text>
            <Icon
              color="disabled"
              sx={{ mr: 1, opacity: 0, 'label:hover &': { opacity: 1 } }}
              {...endIcon}
            />
          </Box>
        ) : (
          label
        )
      }
      labelPlacement="end"
      slotProps={{
        typography: {
          ...TextProps,
          sx: { 'label:hover &': { color: 'text.primary' } }
        }
      }}
      sx={{
        mx: 0,
        width: fullWidth ? '100%' : undefined,
        ...sx,
        ['&:hover']: {
          bgcolor: hover ? 'action.hover' : undefined
        }
      }}
    />
  )
}

export default RadioItem
